
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/talon-one",
      function () {
        return require("private-next-pages/destinations/talon-one.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/talon-one"])
      });
    }
  